// extracted by mini-css-extract-plugin
export default {"container":"SavedTab_container__h1V1H","container_paymentsBlock":"SavedTab_container_paymentsBlock__R0P08"};